import gql from "graphql-tag";

// fragment
export const PRODUCT_ITEM_FRAGMENT = gql`
    fragment productItem on ProductItemNode {
        id
        plant {
            id
            name
        }
        color {
            id
            color
        }
        potSize {
            id
            potSizeCm
        }
        environment {
            id
            environment
        }
        tag {
            id
            tag
        }
        numPlants
        priority
        updatedAt
        updatedBy
    }
`;

// all query
export const PRODUCT_ITEMS_QUERY = gql`
    query {
        tenantProductItems {
            edges {
                node {
                    ...productItem
                }
            }
        }
    }
    ${PRODUCT_ITEM_FRAGMENT}
`;

// single query
export const SINGLE_PRODUCT_ITEM_QUERY = gql`
    query productItem($id: ID!) {
        productItem(id: $id) {
            ...productItem
        }
    }
    ${PRODUCT_ITEM_FRAGMENT}
`;

// create
export const CREATE_PRODUCT_ITEM_MUTATION = gql`
    mutation createProductItem($input: CreateProductItemInput!) {
        createProductItem(input: $input) {
            productItem {
                ...productItem
            }
        }
    }
    ${PRODUCT_ITEM_FRAGMENT}
`;

// update
export const UPDATE_PRODUCT_ITEM_MUTATION = gql`
    mutation updateProductItem($input: UpdateProductItemInput!) {
        updateProductItem(input: $input) {
            productItem {
                ...productItem
            }
        }
    }
    ${PRODUCT_ITEM_FRAGMENT}
`;

// delete
export const DELETE_PRODUCT_ITEM_MUTATION = gql`
    mutation deleteProductItem($input: DeleteProductItemInput!) {
        deleteProductItem(input: $input) {
            productItem {
                ...productItem
            }
        }
    }
    ${PRODUCT_ITEM_FRAGMENT}
`;
